"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUnderline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M15.997 4c.666-.002 1 .33 1 .994v5.002c0 1.02 0 6.005-4.963 6.004C7.07 16 7 11.575 7 9.994v-5C6.998 4.331 7.33 4 7.997 4c.666 0 1 .331 1 .994v5.002c0 1.064.07 4.005 3.037 4.005C15 14.001 15 11.065 15 9.994V5c-.002-.665.33-.998.997-1zM4 19c0-.667.333-1 1-1h14c.667 0 1 .333 1 1s-.333 1-1 1H5c-.667 0-1-.333-1-1z' }))); };
exports.default = SvgUnderline;
//# sourceMappingURL=Underline.js.map